import { WebEditorContext, TextLibraryContext } from "../../../../contexts";
import { useContext } from "react";
import * as Constants from "../../../../utils/constants"
import TextLibraryComponent from "./textLibraryComponent";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';
import { resources, translations } from "../../../../translations/translationsConstants";

export default function TextLibrarySideBar() {
    const { editorFileRef, handleActionMenuBar, setSideBarState } = useContext(WebEditorContext);
    const { setSelectedEditorInsertPoint } = useContext(TextLibraryContext);
    const { t: te } = useTranslation([resources.edit]);

    const handleOpen = (value) => {
        if (!value) {
            handleActionMenuBar({
                editorFile: editorFileRef.current,
                actionMenuBar: {
                    textLibraryState: Constants.normalState,
                },
            })
        }

        if (value) {
            setSideBarState(Constants.sideBarState.textLibrary);
        } else {
            setSideBarState(Constants.sideBarState.closed);
        }
        setSelectedEditorInsertPoint(null);
    }

    return (
        <div className="tw-h-full tw-w-full tw-flex tw-flex-col">
            <div className="tw-flex-shrink-0 tw-border-b">
                {/* Header */}
                <div className="tw-px-4 tw-py-6 sm:tw-px-6">
                    <div className="tw-flex tw-items-start tw-justify-between tw-space-x-3">
                        <div className="tw-space-y-1 tw-text-gray-700 tw-text-md tw-font-medium ">
                            {te(translations.edit.library.textLibrary)}
                        </div>
                        <div className="tw-h-7 tw-flex tw-items-center">
                            <button
                                type="button"
                                className=" tw-rounded-md tw-text-indigo-700 hover:tw-text-gray-500 tw-cursor-pointer"
                                onClick={() => handleOpen(false)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleOpen(false);
                                    }
                                }}
                            >
                                <span className="tw-sr-only">{te(translations.edit.closePanel)}</span>
                                <XMarkIcon className="tw-h-6 tw-w-6" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw-w-full tw-h-full tw-py-5">
                <TextLibraryComponent />
            </div>
        </div>
    )
}